/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { deliveryCitySchema } from "./deliveryCitySchema.ts";
import { deliveryKindSettingsSchema } from "./deliveryKindSettingsSchema.ts";
import { deliveryZoneSchema } from "./deliveryZoneSchema.ts";

export const deliverySettingsResponseSchema = z.object({
	is_enabled: z.boolean(),
	courier: deliveryKindSettingsSchema,
	pickup: deliveryKindSettingsSchema,
	min_sum: z.number().nullable().describe("Минимальная сумма доставки, если она одна для всех зон; иначе — после проверки адреса."),
	default_city: deliveryCitySchema.nullable(),
	cities: z.array(deliveryCitySchema),
	zones: z.array(deliveryZoneSchema),
	preorder_days: z.int(),
	slot_step_minutes: z.int(),
});
